import { Invoice } from '../../types';

// Mock invoices database
export let mockInvoices: Invoice[] = [
  {
    id: '1',
    invoiceNumber: '#245',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '2',
    invoiceNumber: '#244',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '3',
    invoiceNumber: '#243',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '4',
    invoiceNumber: '#242',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '5',
    invoiceNumber: '#241',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '6',
    invoiceNumber: '#240',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '7',
    invoiceNumber: '#239',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '8',
    invoiceNumber: '#238',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '9',
    invoiceNumber: '#237',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '10',
    invoiceNumber: '#236',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
  {
    id: '11',
    invoiceNumber: '#235',
    customerName: 'Nguyễn Cẩm Nhung',
    idCard: '03123456789',
    service: 'Khám tại phòng khám',
    totalAmount: 120000,
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
  },
];

